module.exports = __webpack_public_path__ + "img/icon-exchange-gray.147de180.svg";